import { useEffect, useState } from 'react';
import DirectInput from '../../../directInput/DirectInput';
import DropdownReg from '../../../dropdownReg/DropdownReg';
import MultiSelect from '../../../multiselect/multiselect';
import Autocomplete from '../../../reusable-ui-components/autoCompleteSearch/Autocomplete';
import styles from './activityQuickView.module.css';
import { fetchDropdowns } from '../../../../pages/supDropdown/dropdownFun/dropdownCRUD';
import { forwardRef } from 'react';
import useSectionHighlightRef from '../../../../hooks/useSectionHighlightRef';
import { fetchTypesData } from '../../../packUploadSection/quickView/fetchTypes/FetchTypes';

const ActivityQuickView = forwardRef(({ activityData, setActivityData, isEdit }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    const diffDrop = ['Easy', 'Medium', 'Difficulty'];
    const [dropdownData, setDropdownData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [typeSel, setTypeSel] = useState('trip');
    const [typesData, setTypesData] = useState([]);
    useEffect(() => {
        fetchTypesData(typeSel, 'Types', setTypesData);
    }, [typeSel]);

    useEffect(() => {
        fetchDropdowns(setDropdownData, setLoading, 0, 10, 'trip', 'dropdown', 'active');
    }, []);

    const baseCitiesData = dropdownData.find((item) => item.heading === 'Base Cities')?.dropdown;

    return (
        <div ref={sectionRef}>
            <h2 className={styles.orgPackUpH2}>Quick View</h2>
            <div className={styles.orgPackUpSecDiv}>
                <MultiSelect
                    label='Type / Category'
                    helperText='*Can select multiple types'
                    name='type'
                    value={activityData.quickView?.type || []}
                    data={typesData}
                    listAll={true}
                    closeListOnItemSelect={false}
                    onChange={(val) => {
                        setActivityData((prev) => ({
                            ...prev,
                            quickView: {
                                ...prev.quickView,
                                type: val
                            }
                        }));
                    }}
                    error={highlightField === 'type'}
                />
                <DropdownReg
                    label='Difficulty'
                    name={'difficulty'}
                    options={diffDrop}
                    value={activityData.quickView?.difficulty}
                    req={true}
                    setFormData={setActivityData}
                    nest='quickView'
                    error={highlightField === 'difficulty'}
                />
                {/* <DirectInput
                    label='Start Time'
                    name='startTime'
                    value={activityData.quickView?.startTime}
                    type='text'
                    placeholder='Ex - 9:00 PM'
                    setFormData={setActivityData}
                    min={6}
                    limit={9}
                    nest='quickView'
                    error={highlightField === 'startTime'}
                />
                <DirectInput
                    label='End Time'
                    name='endTime'
                    value={activityData.quickView?.endTime}
                    type='text'
                    placeholder='Ex - 9:00 PM'
                    setFormData={setActivityData}
                    min={6}
                    limit={9}
                    nest='quickView'
                    error={highlightField === 'endTime'}
                /> */}
                <DirectInput
                    label='Duration'
                    name='duration'
                    value={activityData.quickView?.duration}
                    type='text'
                    placeholder='2D/1N Or Hours'
                    setFormData={setActivityData}
                    min={2}
                    limit={9}
                    nest='quickView'
                    error={highlightField === 'duration'}
                />
                {/* <DirectInput
                    label='Where'
                    name='where'
                    value={activityData.quickView?.where}
                    type='text'
                    placeholder='Add Google location'
                    setFormData={setActivityData}
                    min={2}
                    limit={30}
                    nest='quickView'
                    error={highlightField === 'where'}
                />
                <DirectInput
                    label='Food'
                    name='food'
                    value={activityData.quickView?.food}
                    type='text'
                    placeholder='Breakfast & Lunch (Veg/Non-Veg)'
                    setFormData={setActivityData}
                    min={2}
                    limit={30}
                    nest='quickView'
                    error={highlightField === 'food'}
                /> */}
                <DirectInput
                    label='Trek Distance'
                    name='trekDistance'
                    value={activityData.quickView?.trekDistance}
                    type='text'
                    placeholder='Trek distance in km (Ex - 2 km), if Not a trek just enter 0 km'
                    setFormData={setActivityData}
                    min={3}
                    limit={8}
                    nest='quickView'
                    error={highlightField === 'trekDistance'}
                />
                <div style={{ display: 'flex' }}>
                    <label className={styles.quickviewLabel}>Base Cities</label>
                    <Autocomplete
                        dropdownData={baseCitiesData || []}
                        selectedData={activityData?.quickView?.baseCities || []}
                        onChange={(updatedArray) => {
                            setActivityData((prev) => ({
                                ...prev,
                                quickView: {
                                    ...prev.quickView,
                                    baseCities: updatedArray
                                }
                            }));
                        }}
                        multiSelect={false}
                        placeholder={'Search base cities'}
                    />
                </div>
                <DirectInput
                    label='Max Slots'
                    name='maxSlots'
                    value={activityData.quickView?.maxSlots}
                    type='text'
                    placeholder='Max slots availible slots(Ex - 20)'
                    setFormData={setActivityData}
                    min={1}
                    limit={3}
                    nest='quickView'
                    error={highlightField === 'maxSlots'}
                />
                <DirectInput
                    label='Area'
                    name='area'
                    value={activityData.quickView?.area}
                    type='text'
                    placeholder='Enter area (Ex - Jaynagar, Whitefield)'
                    setFormData={setActivityData}
                    min={3}
                    limit={20}
                    nest='quickView'
                    error={highlightField === 'area'}
                />
            </div>
        </div>
    );
});

export default ActivityQuickView;
